import axiosInstance from './axiosInstance';
import { endpoints } from './endPoints';
import {
  setSessionProfile,
  clearSessionProfile,
} from 'shared/utils/sessionProfileStore';

function extractProfileUserId(profile) {
  if (!profile) return null;
  const id = profile.id ?? profile.user?.id;
  return id != null ? id : null;
}

/**
 * Loads user details, tenant branding, group IDs, and permission codes (server uses Redis when warm).
 * Uses HttpOnly access cookie (withCredentials); no token in JS.
 * @returns {Promise<object|null>} API `data` (UserContext shape) or null
 */
export async function fetchSessionContext() {
  try {
    const response = await axiosInstance.get(endpoints.authentication.sessionContext);
    if (
      response?.status === 200 &&
      response.data?.code === '0' &&
      response.data?.data
    ) {
      const profile = response.data.data;
      if (!extractProfileUserId(profile)) {
        console.error('fetchSessionContext: response missing user id', profile);
        clearSessionProfile();
        return null;
      }
      setSessionProfile(profile);
      return profile;
    }
  } catch (e) {
    console.error(
      'fetchSessionContext:',
      e?.response?.data?.message || e.message
    );
  }
  clearSessionProfile();
  return null;
}

export { extractProfileUserId };
